import {createClassLogger, Logger} from '../../utils/Logging';
import {createBridgeCaller} from '../BridgeApi';
import {AccountLinkingBridge, AccountLinkingResponseCallback} from '../accountLinkingBridge';

const BRIDGE_NAME = 'accountlinking';
const logger: Logger = createClassLogger('AccountLinkingBridge:Launcher');
const executeAccountLinkBridgeCall = createBridgeCaller(BRIDGE_NAME, logger);

const accountLinkingLauncher: AccountLinkingBridge = {
    /**
     * Trigger the account linking flow for the specified account type
     */
    linkAccount: (accountType: string): Promise<void> =>
        executeAccountLinkBridgeCall('linkaccount', [accountType]),

    /**
     * Callback that can be registered to know about significant events as they happen
     */
    registerResponseCallback: (callback: AccountLinkingResponseCallback): Promise<void> =>
        executeAccountLinkBridgeCall('registerresponsecallback', [callback])
};

export default accountLinkingLauncher;
